<template>
    <div class="w-full mx-auto relative flex flex-col text-left p-12 lg:p-24"
        style="max-width: 1400px; min-height: calc(100vh - 80px);">

        <h1 class="text-3xl font-bold">Impressum</h1>
        <p class="mt-5">
            Pfarramt Rastenberg<br>
            Lossaer Str. 8<br>
            99636 Rastenberg
        </p>

        <h2 class="text-lg font-bold mt-10 mb-5">Vertreten durch</h2>
        <p>
            Pfarrer<br>
            Hans-Ulrich Bayer
        </p>

        <h2 class="text-lg font-bold mt-10 mb-5">Kontakt</h2>
        <p class="flex"><span class="font-bold w-20">Telefon</span>036377 / 80324<br></p>
        <p class="flex"><span class="font-bold w-20">E-Mail</span>pfarramt.rastenberg@ekmd.de</p>
    </div>
</template>